/**
 * Descarga de la aceptación de términos de domiciliación (perfil del cliente → métodos de pago).
 * Lógica pura: sin Angular, para probarla con node (test/domiciliacion-aceptaciones.test.mjs).
 * Ojo: se escribe con anotaciones simples porque el test carga este .ts sin compilador.
 */

export const PERMISO_DESCARGAR_ACEPTACION = 'contactos.domiciliacion.descargar_aceptacion';
export const NOMBRE_PDF_RESPALDO = 'aceptacion-domiciliacion.pdf';

/**
 * Solo con el permiso y ESTRICTO como el núcleo: sin RBAC el núcleo responde 403, y `hasPermission` a secas
 * deja pasar todo (ver liquidacion/marcas.ts). Sin el permiso no se llama al listado.
 */
export const puedeDescargarAceptacion = (auth: any): boolean =>
  !!auth && !!auth.hasRbac$ && auth.hasRbac$.getValue() === true && auth.hasPermission(PERMISO_DESCARGAR_ACEPTACION) === true;

/** Las aceptaciones de UNA cuenta (método de pago del cliente), en el orden que llegaron (ascendente por fecha). */
export const aceptacionesDeCuenta = (aceptaciones: any, cuentaId: any): any[] =>
  Array.isArray(aceptaciones) && cuentaId
    ? aceptaciones.filter((a: any) => a && String(a.payment_method_customer) === String(cuentaId))
    : [];

/** Nombre del archivo según `Content-Disposition` (filename*= UTF-8 o filename="…"); con respaldo si no viene. */
export const nombreArchivoDeCabecera = (cabecera: any): string => {
  const c = String(cabecera || '');
  const utf = /filename\*\s*=\s*UTF-8''([^;]+)/i.exec(c);
  if (utf) {
    try { const n = decodeURIComponent(utf[1].trim()).replace(/[\\/]/g, '_'); if (n) return n; } catch (e) { /* cae al siguiente */ }
  }
  const simple = /filename\s*=\s*"([^"]+)"|filename\s*=\s*([^;]+)/i.exec(c);
  const n = simple ? String(simple[1] || simple[2]).trim().replace(/[\\/]/g, '_') : '';
  return n || NOMBRE_PDF_RESPALDO;
};
